import {Circle, MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents, MarkerCluster} from 'react-leaflet';
import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {Icon, divIcon} from 'leaflet';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonIcon from '@mui/icons-material/Person';

import Prospect from '../../../assets/images/prospect.png';
import ProspectOp from '../../../assets/images/prospect_op.png';
import Cliente from '../../../assets/images/clienteMarker.png';

import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'leaflet/dist/leaflet.css';
import LocationMarker from './LocationMarker';
import _debounce from 'lodash.debounce';
import {useHistory} from 'react-router-dom';
import {getPontosMapa} from '../../../pages/requests';

// const clientes = [
//     {
//         id: 100016,
//         cliente: 'AFRIC ASPHALTE',
//         latitude: 41.38344,
//         longitude: -8.76364,
//         days: 3,
//         isProspect: false,
//     },
//     {
//         id: 100016,
//         cliente: 'AFRIC ASPHALTE 2',
//         latitude: 41.38344,
//         longitude: -8.76364,
//         days: 4,
//         isProspect: false,
//     },
//     {
//         id: 100002,
//         cliente: '2LPE Distribution',
//         latitude: 41.397,
//         longitude: -8.723,
//         days: 1,
//         isProspect: true,
//     },
//     {
//         id: 100902,
//         cliente: 'MEL - Razão',
//         latitude: 41.431,
//         longitude: -8.777,
//         days: 365,
//         isProspect: false,
//     },
//     {
//         id: 100732,
//         cliente: 'EQUIPAMENTOS S.A.',
//         latitude: 41.406,
//         longitude: -8.747,
//         days: 10,
//         isProspect: true,
//     },
// ];

function Mapa({onRowClick, valorMax, valorMin, setValorMax, setValorMin, max, min, setMax, setMin}) {
    const fillBlueOptions = {fillColor: 'blue'};
    const center = [41.38344, -8.76364];
    const [mapHeight, setMapHeight] = useState(window.innerHeight * 0.8);
    const history = useHistory();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const [clientes, setClientes] = useState([]);

    useEffect(() => {
        getPontosMapa(lang).then(res => {
            setClientes(res.data.pontosMapa);
        });
    }, []);

    useEffect(() => {
        debugger;
        const minDays = clientes.reduce((min, client) => Math.min(min, client.days), Infinity);
        const maxDays = clientes.reduce((max, client) => Math.max(max, client.days), -Infinity);

        setMin(minDays);
        setMax(maxDays);
        setValorMin(minDays);
        setValorMax(maxDays);
    }, [clientes]);

    function pushConta(client) {
        history.push(`Prospects?conta=${client.id}`);
        history.push(`Prospects`);
        onRowClick(client);
    }
    const customIcon = new L.Icon({
        iconUrl: require('../../../assets/images/prospect_op.png').default,
        iconSize: new L.Point(40, 47),
    });
    const createClusterCustomIcon = function (cluster: MarkerCluster) {
        return L.divIcon({
            html: `<span>${cluster.getChildCount()}</span>`,
            className: 'custom-marker-cluster',
            iconSize: L.point(33, 33, true),
        });
    };

    const clientesFilt = clientes.filter(x => x.days >= valorMin && x.days <= valorMax);

    return (
        <MapContainer center={[41.38344, -8.76364]} zoom={13} scrollWheelZoom={true} style={{height: `${mapHeight}px`}}>
            <LocationMarker />
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {/* <Circle center={center} pathOptions={fillBlueOptions} radius={2000} /> */}

            <MarkerClusterGroup>
                {clientesFilt.map(client => (
                    <Marker
                        key={client.id}
                        position={[client.latitude, client.longitude]}
                        icon={
                            new divIcon({
                                html: ` <div class="flex justify-center items-center">
                                        <div class="relative">
                                            <img  style=" width:45px; height:50px" class="" src=${client.isProspect ? ProspectOp : Cliente} />
                                            <h6 class="text-extrabold  text-xl absolute top-7 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1 font-bold" style="font-family: "Gill Sans Extrabold", sans-serif;">${` ${
                                                client.days > 999 ? 999 : client.days
                                            }`}</h6>
                                        </div>          
                                    </div>`,
                                // iconUrl: `${client.isProspect ? Prospect : Cliente}`,
                                className: `bg-${client.isProspect ? 'red' : 'red'} rounded-full  items-center flex`,
                                iconSize: [40, 40],
                                iconAnchor: [20, 40],
                                popupAnchor: [0, -20],
                                shadowAnchor: [6, 100],
                            })
                        }
                        eventHandlers={{
                            mouseover: e => {
                                e.target.openPopup();
                            },
                            click: e => {
                                e.target.openPopup();
                            },
                        }}>
                        <Popup>
                            <span className="text-sm flex items-center font-semibold hover:underline cursor-pointer hover:text-blue-600" onClick={() => pushConta(client)}>
                                {client.isProspect ? <PersonIcon /> : <PersonSearchIcon />} ({client.days}) {client.id} | {client.cliente}
                            </span>
                        </Popup>
                    </Marker>
                ))}{' '}
            </MarkerClusterGroup>
        </MapContainer>
    );
}

export default Mapa;
